import { LOADING } from "./types";

export const startLoading = () => {
  return {
    type: LOADING,
    payload: true,
  };
};
